import { useMutation, useQueryClient } from "@tanstack/react-query";
import { authApi } from "./api";
import { qk } from "../../lib/queryKeys";

export const useCreateUser = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.createUser,
    onSuccess: () => qc.invalidateQueries({ queryKey: qk.me() }),
  });
};

export const useLogin = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.login,
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: qk.me() });
    },
  });
};

export const useChangePassword = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.changePassword,
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: qk.me() });
    },
  });
};

export const useChangePasswordTemporary = () => {
  return useMutation({
    mutationFn: authApi.changePasswordTemporary,
  });
};

export const useLogout = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.logout,
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: qk.me() });
    },
  });
};

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: authApi.forgotPassword,
  });
};

export const useConfirmForgotPassword = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.confirmForgotPassword,
    onSuccess: () => qc.invalidateQueries({ queryKey: qk.me() }),
  });
};

export const useUpdateConsent = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: authApi.updateConsent,
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: qk.me() });
    },
  });
};

export const useVerifyUserInvite = () => {
  return useMutation({
    mutationFn: authApi.verifyUserInvite,
  });
};

export const useCompleteUserInvite = () => {
  return useMutation({
    mutationFn: authApi.completeUserInvite,
  });
};

export const useRequestUserInvite = () => {
  return useMutation({
    mutationFn: authApi.requestUserInvite,
  });
};

export const useVerifyPasswordReset = () => {
  return useMutation({
    mutationFn: authApi.verifyPasswordReset,
  });
};

export const useCompletePasswordReset = () => {
  return useMutation({
    mutationFn: authApi.completePasswordReset,
  });
};
